import HealthGorillaLanding from '~/components/maud/healthGorillaLanding';

const HealthGorillaLandingPage = () => <HealthGorillaLanding />;

export default HealthGorillaLandingPage;
